<div class="close-btn">
    <mat-icon matDialogClose class="cursor-pointer material-icons_grey">close</mat-icon>
</div>
<div class="personal-manager-container">
    <ng-container *ngIf="!!personalManager; else noManager">
        <div class="user-info">
            <div class="user-info-name-label">Персональний менеджер</div>
            <div class="user-info-name">{{ name }}</div>
            <span class="copy-content user-info-phone-wrapper">
                <i (click)="goTo(tel)" class="material-icons user-info-icon cursor-pointer">phone</i>
                <a [href]="tel" target="_blank" class="user-info-phone">
                    {{ personalManager?.Phone }}
                    <button mat-icon-button class="copy-content__btn"
                            [appCopy]="telToCopy"
                            [matTooltip]="'Скопіювати'" matTooltipPosition="below">
                      <mat-icon class="material-icons_grey copy-content__icon">content_copy</mat-icon>
                    </button>
                </a>
            </span>
            <span class="copy-content user-info-email-wrapper">
                <i (click)="goTo(mailTo)" class="material-icons user-info-icon cursor-pointer">email</i>
                <a [href]="mailTo" target="_blank" class="user-info-phone">
                    {{ personalManager?.EMail }}
                    <button mat-icon-button class="copy-content__btn"
                            [appCopy]="personalManager?.EMail"
                            [matTooltip]="'Скопіювати'" matTooltipPosition="below">
                      <mat-icon class="material-icons_grey copy-content__icon">content_copy</mat-icon>
                    </button>
                </a>
            </span>
        </div>
    </ng-container>

    <ng-template #noManager>
        <div class="user-info-name-label pb-2">Персональний менеджер</div>
        <app-personal-manager-stub></app-personal-manager-stub>
    </ng-template>
</div>